import ApolloClient from "apollo-boost";
import { InMemoryCache } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';

export const client = new ApolloClient({
    uri: `${process.env.REACT_APP_API_BASE_URL}/graphql`
});

export function getAuthenticationClient(token){
    const access_token = token;
    const headers = {
      authorization: access_token ? `Bearer ${access_token}` : null,
      fetchOptions: { fetch },
    };
    const httpLink = new createHttpLink({
      uri: `${process.env.REACT_APP_API_BASE_URL}/graphql`,
      headers: headers
    });
    return new ApolloClient({
      link: httpLink,
      cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
      fetchOptions: { fetch }
    });
}

export default {client,getAuthenticationClient};